
export const sendEvent = (eventName, data) => {
    console.log('event: ', eventName, 'data: ', data)
    if (window.gtag) {
        gtag('event', eventName, data);
    }
}
document.querySelectorAll('a[href^="tel:"]').forEach(link => {
    link.addEventListener('click', function () {
        sendEvent("key_phone", {});
    });
});
document.querySelectorAll('a[href^="mailto:"]').forEach(link => {
    link.addEventListener('click', function () {
        sendEvent("key_email", {});
    });
});
